import { FormControl, Stack, useTheme } from '@mui/material';
import { OTPLoginContext } from 'Context/OTPLoginContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { useContext, useRef } from 'react';
import { PersonalDetails } from './PersonalDetails';
import { ContactDetails } from './ContactDetails';
import { ArrowButton } from 'Modules/OTPLogin/ArrowButton';
import { CustomMetaTitle } from 'Components';

export const PersonalDetailsForm = () => {
  const { step, setStep, isFormValidated, errors } =
    useContext(OTPLoginContext);
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.OTP_Login
  ).personalDetailsForm;

  const palette = useTheme().palette;

  const formRef = useRef<HTMLFormElement | null>(null);

  const nextStepHandler = () => {
    const { isValid, firstErrorName } = isFormValidated();

    if (isValid) setStep(step + 1);
    else if (formRef.current) {
      const element = formRef.current.querySelector(
        `[name="${firstErrorName}"]`
      ) as HTMLElement | null;
      if (element) element.focus();
    }
  };

  return (
    <>
      <CustomMetaTitle
        disablePrefix
        title={
          Dictionary[DICTIONARY.OTP_Login].metaTitle +
          ' - ' +
          Dictionary[DICTIONARY.OTP_Login].metaTitleStep.stepTwo
        }
      />
      <Stack maxWidth={isDesktop ? '552px' : '342px'} alignItems={'center'}>
        <Stack component={'form'} ref={formRef}>
          <FormControl aria-label={dictionary.formName} component='fieldset'>
            <legend>{dictionary.formName}</legend>
            <PersonalDetails />
            <ContactDetails />
          </FormControl>
        </Stack>
        <Stack
          direction='row'
          maxWidth={isDesktop ? 'initial' : '327px'}
          gap={isDesktop ? '84px' : '42px'}
        >
          <ArrowButton
            text={dictionary.backwards}
            onClick={() => setStep(step - 1)}
            buttonVariant={'secondary1'}
            typographyVariant={'body4'}
            arrowColor={palette.primary.main}
            arrowPosition='right'
          />
          <ArrowButton
            text={dictionary.forward}
            onClick={nextStepHandler}
            buttonVariant={'primary1'}
            typographyVariant={'body4'}
            arrowColor={'#fff'}
            arrowPosition='left'
          />
        </Stack>
      </Stack>
    </>
  );
};
